module.exports = __webpack_public_path__ + "img/isTyping.d62efbce.gif";